import type { GuideConfig } from '@/data/types';

interface GuideStartProps {
  config: GuideConfig;
  onStart: () => void;
}

export default function GuideStart({ config, onStart }: GuideStartProps) {
  return (
    <div className="flex-1 flex flex-col items-center bg-static-white px-5 pt-40 md:pt-28 pb-16">
      <div className="w-full max-w-[400px] mx-auto text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-fill-normal text-accent-brown text-label2 font-medium mb-5">
          {config.plannerIntro}
        </span>

        <h1 className="font-serif text-[28px] md:text-[32px] text-label-normal mb-3 leading-[1.35] whitespace-pre-line">
          {config.startTitle}
        </h1>

        <p className="text-[15px] text-label-alt mb-6 leading-relaxed whitespace-pre-line">
          {config.startDescription}
        </p>

        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="flex items-center gap-1.5 text-label2 text-label-assistive whitespace-nowrap">
            <i className="ri-question-answer-line text-label-alt text-sm"></i>
            <span>{config.questionCount}문항</span>
          </div>
          <div className="w-px h-3 bg-line-divider"></div>
          <div className="flex items-center gap-1.5 text-label2 text-label-assistive whitespace-nowrap">
            <i className="ri-time-line text-label-alt text-sm"></i>
            <span>{config.estimatedTime}</span>
          </div>
          <div className="w-px h-3 bg-line-divider"></div>
          <div className="flex items-center gap-1.5 text-label2 text-label-assistive whitespace-nowrap">
            <i className="ri-shield-check-line text-label-alt text-sm"></i>
            <span>플래너 기준</span>
          </div>
        </div>

        <button
          onClick={onStart}
          className="w-full h-[52px] rounded-full bg-primary-normal text-static-white text-[15px] font-semibold hover:bg-primary-strong transition-colors flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap"
        >
          {config.startCtaText}
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
    </div>
  );
}